export const HotelErrorToErrorMessageMapping = {
  CampaignServiceInvalidDeviceTargetBidAdjustment: _TL_('The bid adjustment is not valid.'),
  CampaignServiceIncompleteDeviceCriterionSet: _TL_('The entity must either be explicitly associated with all device criterion types (Computer, Tablet, Smartphone) or should not have any device criterion.'),
  InvalidCheckInDateTarget: _TL_('The check-in date target is not valid.'),
};
